import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function ProductionRedirect() {
  const { role, code } = useParams();
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!role || !code) {
      setErr("Invalid link — missing role or code.");
      return;
    }

    let cancelled = false;

    fetch(`/api/p/${encodeURIComponent(role)}/${encodeURIComponent(code)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (cancelled) return;
        if (r.ok && data.redirect_url) {
          window.location.replace(data.redirect_url);
          return;
        }
        const detail =
          typeof data.detail === "string"
            ? data.detail
            : r.status === 404
              ? "Invalid or expired link code."
              : "Could not open this production link.";
        setErr(
          `${detail} Ask manager to resend WhatsApp for this order (code ${code}).`
        );
      })
      .catch(() => {
        if (!cancelled) {
          setErr(
            "Could not reach the server. Check internet and try again, or ask manager for a fresh link."
          );
        }
      });

    return () => {
      cancelled = true;
    };
  }, [role, code]);

  if (err) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#FBF8F1",
          fontFamily: "sans-serif",
          padding: 24,
        }}
      >
        <div
          style={{
            maxWidth: 420,
            textAlign: "center",
            border: "1px solid #EBB3A9",
            borderRadius: 16,
            background: "#fff",
            padding: 24,
          }}
        >
          <p style={{ color: "#C2185B", fontWeight: 700, fontSize: 18, marginBottom: 12 }}>
            Link not valid
          </p>
          <p style={{ color: "#555", fontSize: 15, lineHeight: 1.5 }}>{err}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FBF8F1",
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: 48,
            height: 48,
            border: "4px solid #EBB3A9",
            borderTopColor: "#EE2677",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px",
          }}
        />
        <p style={{ color: "#2D2D2D", fontSize: 16 }}>Opening task…</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
